import { fetchWithAuth } from './auth';
import { API_BASE } from '../config';

export type InboundLinePayload = {
    /** Товар в MySQL: по нему сервер прибавляет остаток (штрихкод есть не у всех карточек). */
    product_id?: number;
    sku?: string;
    brand?: string;
    partNumber?: string;
    model?: string;
    category?: string;
    qty: number;
    unitCost: number;
    totalCost: number;
    quality: 'original' | 'copy';
};

export type InboundPayload = {
    id: string;
    supplier: string;
    status: 'ready' | 'processing' | 'in_transit';
    created_at?: string;
    lines: InboundLinePayload[];
};

export async function apiGetInbounds(): Promise<any[]> {
    const res = await fetchWithAuth(`${API_BASE}/inbound`);
    if (!res.ok) throw new Error(`Ошибка загрузки поступлений: ${res.status}`);
    return res.json();
}

export async function apiCreateInbound(payload: InboundPayload): Promise<void> {
    const res = await fetchWithAuth(`${API_BASE}/inbound`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(`Ошибка сохранения: ${res.status}`);
}

export type InboundLineUpdatePayload = {
    qty: number;
    unitCost: number;
    brand?: string;
    partNumber?: string;
};

export async function apiUpdateInboundLine(lineId: string | number, data: InboundLineUpdatePayload): Promise<void> {
    const res = await fetchWithAuth(`${API_BASE}/inbound/line/${lineId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(`Ошибка обновления: ${res.status}`);
}

export async function apiDeleteInbound(id: string): Promise<void> {
    const res = await fetchWithAuth(`${API_BASE}/inbound/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error(`Ошибка удаления: ${res.status}`);
}
